module.exports = __webpack_public_path__ + "img/mockup-3.d7377e46.png";